import { Tooltip, type TooltipProps } from "@mui/material";
import { type ReactNode } from "react";

interface InfoTooltipProps {
  title: ReactNode;
  placement?: TooltipProps["placement"];
  children: TooltipProps["children"];
}

/**
 * Wrapper around MUI Tooltip with consistent dark background and other styling.
 */
export function InfoTooltip(props: InfoTooltipProps) {
  const { title, placement = "bottom-end", children } = props;

  return (
    <Tooltip
      placement={placement}
      slotProps={{
        popper: {
          modifiers: [{ name: "offset", options: { offset: [0, -8] } }],
        },
        tooltip: {
          sx: (theme) => ({
            backgroundColor: theme.palette.base?.base,
            borderRadius: 3,
            paddingX: 4,
            paddingY: 3,
          }),
        },
      }}
      title={title}
    >
      {children}
    </Tooltip>
  );
}
